import {
  DataVersion,
  IncidentNeighbourAlarmsResponse,
  IncidentProduct,
} from '@hakimo-ui/hakimo/types';
import { withDataVersion } from '@hakimo-ui/hakimo/util';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useIncidentNeighbourAlarms(
  alarmId: number | string | undefined,
  product: IncidentProduct,
  dataVersion?: DataVersion
) {
  const searchParams = new URLSearchParams({ product });
  const request = new Request(
    `/v2/orm/location_incidents/get_neighbour_la/${alarmId}` +
      `?${searchParams.toString()}`
  );
  withDataVersion(request, dataVersion);

  return useAuthenticatedRequest<IncidentNeighbourAlarmsResponse>(request, {
    queryKey: ['incidentNeighbourAlarms', { alarmId, product, dataVersion }],
    responseModifier: async (response: Response) => response.json(),
    enabled: !!alarmId,
  });
}

export default useIncidentNeighbourAlarms;
